import { collection, doc, type Firestore } from "firebase/firestore";

export const paths = {
  user: (uid: string) => ["users", uid] as const,
  household: (hid: string) => ["households", hid] as const,
  members: (hid: string) => ["households", hid, "members"] as const,
  member: (hid: string, uid: string) =>
    ["households", hid, "members", uid] as const,
  chores: (hid: string) => ["households", hid, "chores"] as const,
  chore: (hid: string, cid: string) =>
    ["households", hid, "chores", cid] as const,
  completions: (hid: string) => ["households", hid, "completions"] as const,
  completion: (hid: string, cid: string) =>
    ["households", hid, "completions", cid] as const,
  transactions: (hid: string) => ["households", hid, "transactions"] as const,
  transaction: (hid: string, tid: string) =>
    ["households", hid, "transactions", tid] as const,
  payouts: (hid: string) => ["households", hid, "payouts"] as const,
  payout: (hid: string, pid: string) =>
    ["households", hid, "payouts", pid] as const,
  fcmTokens: (hid: string) => ["households", hid, "fcmTokens"] as const,
  fcmToken: (hid: string, tid: string) =>
    ["households", hid, "fcmTokens", tid] as const,
  choreProposals: (hid: string) =>
    ["households", hid, "choreProposals"] as const,
  choreProposal: (hid: string, pid: string) =>
    ["households", hid, "choreProposals", pid] as const,
  instantSubmissions: (hid: string) =>
    ["households", hid, "instantSubmissions"] as const,
  instantSubmission: (hid: string, sid: string) =>
    ["households", hid, "instantSubmissions", sid] as const,
  goals: (hid: string) => ["households", hid, "goals"] as const,
  goal: (hid: string, gid: string) =>
    ["households", hid, "goals", gid] as const,
  moneyTalks: (hid: string) => ["households", hid, "moneyTalks"] as const,
  moneyTalk: (hid: string, weekKey: string) =>
    ["households", hid, "moneyTalks", weekKey] as const,
};

export function refDoc(db: Firestore, path: readonly string[]) {
  const [first, ...rest] = path;
  return doc(db, first, ...rest);
}

export function refCol(db: Firestore, path: readonly string[]) {
  const [first, ...rest] = path;
  return collection(db, first, ...rest);
}
